import React from 'react';
import { FadeIn } from './FadeIn';
import { Quote } from 'lucide-react';
export function PainSection() {
  return <section className="py-12 md:py-20 px-4 max-w-3xl mx-auto" data-id="element-74">
      <FadeIn data-id="element-75">
        <div className="text-center mb-12 md:mb-16 space-y-6 md:space-y-8" data-id="element-76">
          <h2 className="text-3xl md:text-5xl font-black text-brand-dark" data-id="element-77">
            Seamos directas un segundo.
          </h2>
          <div className="text-lg md:text-2xl text-brand-muted font-medium space-y-6 leading-relaxed" data-id="element-78">
            <p data-id="element-79">
              Elegiste veterinaria porque te apasiona. Porque querés curar,
              operar, acompañar a los dueños cuando más te necesitan.
            </p>
            <p data-id="element-80">
              No elegiste veterinaria para quedarte después de cerrar el
              consultorio redactando historias clínicas, presupuestos y planes
              sanitarios que ya hiciste cincuenta veces con otros datos.
            </p>
            <p className="font-black text-brand-dark text-2xl md:text-3xl pt-4" data-id="element-81">
              Y sin embargo, ahí estás.
            </p>
          </div>
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-82">
        <div className="bg-brand-white border-l-4 border-brand-gold rounded-r-2xl p-8 md:p-12 relative shadow-sm" data-id="element-83">
          <Quote className="absolute top-6 left-6 text-brand-cream w-16 h-16 md:w-24 md:h-24 -z-0 rotate-180" data-id="element-84" />
          <p className="text-xl md:text-3xl font-medium text-brand-dark leading-relaxed italic relative z-10" data-id="element-85">
            "Después de las consultas me quedo escribiendo. Siempre. Lo que más
            me cansa no es el trabajo clínico, es todo lo demás."
          </p>
        </div>
      </FadeIn>
    </section>;
}